import React from 'react';
import { SectionHeader } from './ui/SectionHeader';
import { CtaButton } from './ui/CtaButton';
import { BONUS_TOTAL, CHECKOUT_URL, PRICE, PRODUCT_NAME } from '../data/content';
export function OfferSection() {
  return <section id="oferta" aria-labelledby="oferta-titulo" className="scroll-mt-2 border-b border-arena bg-arena/40" data-id="element-95" data-mp="8mn4mdpzojyr">
      <div className="mx-auto max-w-xl px-4 py-6 sm:py-9" data-id="element-96" data-mp="dfq412hg6nmv">
        <SectionHeader id="oferta-titulo" eyebrow="Oferta especial — Sistema completo 6 en 1" title="Comienza hoy desde cero y avanza a tu ritmo." data-id="element-97" data-mp="idrmpmayokxt" />

        <div className="mt-4 rounded-2xl border-[3px] border-dashed border-terracota bg-crudo p-4 text-center shadow-[0_0_0_6px_rgb(184_92_56/0.1)] sm:p-5" data-id="element-98" data-mp="re69kq3kq83f">
          <p className="text-sm font-extrabold text-terracota sm:text-base" data-id="element-99" data-mp="wc7z9tvi95nv">🧶 {PRODUCT_NAME}</p>
          <p className="text-sm font-bold text-marron" data-id="element-100" data-mp="2t742sn19j2ow">6 Tomos + 5 Bonos</p>
          <p className="mt-1 text-sm font-medium text-marron" data-id="element-101" data-mp="2y55m992lp40w">🎁 Bonos valorados en {BONUS_TOTAL}</p>

          <p className="mx-auto mt-2.5 inline-block rounded-md bg-terracota px-3 py-1 text-xs font-extrabold uppercase text-crudo" data-id="element-102" data-mp="12oa78rpgq1hn">
            🔥 Oferta especial
          </p>
          <p className="mt-1.5 font-serif text-5xl leading-none text-marron sm:text-6xl" data-id="element-103" data-mp="swxhc5n85le9">
            Hoy: <span className="text-terracota" data-id="element-104" data-mp="owwqflixvhqb">{PRICE}</span>
          </p>
          <p className="mt-1.5 text-xs font-medium text-marron/75 sm:text-sm" data-id="element-105" data-mp="1lme3wmo5y82k">
            Pago único • Sin mensualidades • Acceso Digital
          </p>

          <CtaButton href={CHECKOUT_URL} className="mt-3" data-id="element-106" data-mp="1gokxbsiy7c1r">
            🚀 SÍ, QUIERO EL SISTEMA COMPLETO POR {PRICE}
          </CtaButton>
          <p className="mt-1.5 text-xs font-medium text-marron/75" data-id="element-107" data-mp="1cnivr51k6nwm">Acceso Inmediato • Garantía de 7 Días</p>
        </div>
      </div>
    </section>;
}